<template>
  <div
    class="delVip"
    v-show="judge"
    :style="{ 'z-index': modaldata.Zindex, }"
    :data-list-size="listSize"
  >
    <div v-show="false" class="vipSpriteBox" @click="stopDocument($event)" v-if="delStep == 0">
      <div class="headBar">
        <span>VIP素材权益清单 （共{{IsVipSprites.data.length}}个VIP权益文件）</span>
        <i class="icon el-icon-close" @click="closeModal($event)"></i>
      </div>
      <div class="scollBox_title">
        <div>场景页码</div>
        <div>类型</div>
        <div>素材</div>
        <div>操作</div>
        <div class="limitBtn">
          权限（全部）
          <div class="limitBox">
            <div
              :class="{
                'limitActive' : limitJudge == 'all'
              }"
              @click="limitJudgeFS('all')"
            >全部</div>
            <div
              :class="{
                'limitActive' : limitJudge == 'pay'
              }"
              @click="limitJudgeFS('pay')"
            >付费</div>
            <div
              :class="{
                'limitActive' : limitJudge == 'vip'
              }"
              @click="limitJudgeFS('vip')"
            >会员专属</div>
          </div>
        </div>
      </div>
      <div class="scollBox">
        <ul
          class="scollBox_page"
          v-for="itemList in vipSprite"
          v-if="itemList.index == currentPage"
          :style="{
            'z-index' : itemList.index == currentPage ? 10 : 0,
          }"
        >
          <li v-for="item in itemList.data">
            <div>{{ item.page }}</div>
            <div>{{ item.name }}</div>
            <div class="thumbnails">
              <div
                class="scenes_thumbnails"
                v-if="item.scale > 0"
                v-html="item.url"
                :style="{
                  'transform': ('scale('+item.scale+','+item.scale+')'),
                }"
              ></div>
              <div
                class="sprite_thumbnails"
                :class="{
                  'uploadVideoNUM' : item.id == 'uploadVideoNUM',
                }"
                v-if="!item.scale"
                v-html="item.url"
              ></div>
            </div>
            <div
              class="lookSprite"
              @click="lookSpritePosition(item)"
              v-analysis="{
                category:'vip_list',
                action:'click_vip_material_browser',
                label:'VIP权益_素材查看',
              }"
            >查看</div>
            <div class="item-price">
              <span class="msg" v-show="item.type === 'TOOLsound' && SoundCoupon.num > 0">券后免费</span>
              <span
                class="is-msg"
                :class="{del: item.type === 'TOOLsound' && SoundCoupon.num > 0}"
                :style="{color: getTextColor(item.limit)}"
              >{{item.limit}}</span>
              <!-- <span class="vip-icon" v-show="(item.limit || '¥').indexOf('') > -1">
                <span>钻</span>
                <div class="vip-icon-tip">
                  企业协作版、企业营销版会员（1年）可免费使用付费素材
                </div>
              </span>-->
            </div>
          </li>
        </ul>
      </div>

      <el-pagination
        class="vip_pagination"
        background
        :hide-on-single-page="true"
        :page-size="7"
        layout="prev, pager, next"
        :total="paginationNum"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>

      <div class="msg-vip" @click="upgradeVIP" style="cursor: pointer;">
        <span>升级动画Pro+可解锁全站素材</span>
      </div>

      <div class="bottom_bens">
        <!-- v-if="limitNum.vip || limitNum.svip" -->
        <span
          class="icon icon_a a_icon up-member"
          @click="(limitNum.vip || limitNum.svip) ? msgpopupsFS('upgradeVIP') : upgradeVIP()"
          v-analysis="{
            category:'vip_list',
            action:'click_vip_update',
            label:'VIP权益_升级会员',
          }"
        >升级会员</span>

        <span v-if="limitNum.price" class="icon a_icon" @click="msgpopupsFS('payPrice')">购买付费资源</span>

        <span
          class="icon delIcon"
          @click="msgpopupsFS('delStep')"
          v-analysis="{
            category:'vip_list',
            action:'click_one_delete_vip',
            label:'VIP权益_一键删除付费素材',
          }"
        >一键删除</span>
      </div>
    </div>

    <div class="delLoad" v-if="delStep == 1">
      <span class="load"></span>正在删除VIP素材中
    </div>

    <div class="delMsg" v-if="delStep == 2">已成功删除所有VIP素材，尝试重新导出视频吧！</div>

    <div class="msgpopups" v-if="judgeMsgpopups.judge">
      <div class="msgpopups_box" :style="isBigDialog() && {
          height: '280px',
        }">
        <div class="delMsgpopups el-icon-close" @click="msgpopupsBtnFS('none')"></div>
        <div
          class="msgpopups_body"
          v-html="judgeMsgpopups.message"
          :style="isBigDialog() && {
            height: 'auto',
            textAlign: 'left'
          }"
        ></div>
        <div class="msgpopups_footer">
          <div
            @click="msgpopupsBtnFS('left')"
            style="background: #5778fb;color: #fff;"
          >{{judgeMsgpopups.btnMsg.left.title}}</div>

          <div @click="msgpopupsBtnFS('right')">{{judgeMsgpopups.btnMsg.right.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import { mapGetters } from "vuex";
import checkPersonVideo from "../mixins/checkPersonVideo";
import {getVipList as getVipSceneEffects} from '@/components/topnav/riskDrop/sceneEffectTypes'

export default {
  mixins: [modal, checkPersonVideo],
  data() {
    return {
      modalName: "delVip",
      allFormJson: false, // 全局是否加载完成
      vipSprite: [], // 所有分页数据循环
      currentPage: 0, // 当前分页数
      delStep: 0, // 删除操作
      limitJudge: "all", // 筛选
      judgeMsgpopups: {
        judge: false,
        type: "",
        message: "",
        btnMsg: {
          left: {
            title: "",
          },
          right: {
            title: "",
          },
        },
      },
      limitNum: {
        price: 0,
        vip: 0,
        svip: 0,
      },
      paginationNum: 0,
      listSize: 0,
    };
  },
  props: {
    boxType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      "SelectSprites_Msg",
      "SelectScenes_Msg",
      "StyleMsg",
      "TOOL",
      "IsVipSprites",
      "UserMsg",
      "UserEquity",
      "UserLevelType",
      "UserLevel",
      "FreeVideoIds",
      "SoundCoupon",
      "isPersonVip",
    ]),
  },
  watch: {
    "IsVipSprites.data": function () {
      // console.log(this.IsVipSprites.data)
      if (this.judge) {
        this.delStep = 0;
        this.currentPage = 1;
        this.limitJudge = "all";
        this.loadVipSprites(this.IsVipSprites.data);
      }
    },
    'judgeMsgpopups.judge' (val) {
      if (!val) {
        this.$bus.emit("Modal_close_vue", { name: 'delVip' });
      }
    },
    limitNum: {
      deep: true,
      handler () {
        if (!this.dataMsg.delVip) {
          return;
        }
        if (this.dataMsg.delVip.popMsg === 'vip') {
          this.msgpopupsFS('upgradeVIP');
        } else if (this.dataMsg.delVip.popMsg === 'pay') {
          this.msgpopupsFS('payPrice');
        } else if (this.dataMsg.delVip.popMsg === 'abandon') {
          this.msgpopupsFS('delStep');
        }
      }
    },
    judge: async function () {
      if (this.judge) {
        if (this.dataMsg.delVip.popMsg === 'vip') {
          this.msgpopupsFS('upgradeVIP');
        } else if (this.dataMsg.delVip.popMsg === 'pay') {
          this.msgpopupsFS('payPrice');
        } else if (this.dataMsg.delVip.popMsg === 'abandon') {
          this.msgpopupsFS('delStep');
        }
        // this.editorLoadMore();
        //对未加载的场景页进行加载
        // this.$bus.emit('loadingAllScenes', 'start')
        // for (let i = 0; i < this.TOOL.sprites.length; i++) {
        //   $(this.$el).hide();
        //   const scenes = this.TOOL.sprites[i];
        //   if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
        //     await this.TOOL.selectScenes(scenes);
        //     await scenes.fromJson(
        //       scenes.unLoadData.json,
        //       this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
        //       true
        //     );
        //   }
        //   //初始化一些动画资源
        //   await scenes.activeAnimation();
        // }
        // this.$bus.emit('loadingAllScenes', 'end')

        $(this.$el).show();

        this.getSoundCoupon();
        this.delStep = 0;
        this.currentPage = 1;
        this.limitJudge = "all";
        this.limitNum.svip = 0;
        this.loadVipSprites(this.IsVipSprites.data);
      }
    },
    currentPage: function () {},
  },
  mounted() {
    this.$bus.on("app.checkedMaterialOnOpenPage", () => {
      let timeoutid = setTimeout(() => {
        this.loadVipSprites(this.IsVipSprites.data);
        this.allFormJson = true;
        clearTimeout(timeoutid);
      }, 1000);
    });
    // /?fontId=d395a156-61e7-4395-ac56-7666742f9c13    将fontid 改成
    this.$bus.on("payPriceEventHref_vue", (data) => {
      if (data.type) {
        this.$bus.emit("FeaturesPop_vue", {
          name: "vipPayment",
          msg: "请在相应的付款页面进行操作",
          btnClose: "遇到问题",
          btnMsg: "付款成功",
          // fs: "paySprite",
          fs: 'payPriceEvent_vue',
          msgType: 2,
          type: 2,
        });
        let hrefUrl =
          "/payResource?resourceId=" + window.location.hash.slice(2);
        window.open(hrefUrl);
      }
      let timeoutid = setTimeout(() => {
        if (!this.IsVipSprites.data.length) {
          this.closeModal();
        }
        clearTimeout(timeoutid);
      }, 200);
    });
  },
  methods: {
    currentChange(data) {
      this.currentPage = data;
    },
    filterPayForMaterial(data = []) {
      let arr = data.filter(v => !v.removed);
      let removed = [];
      let temp = data.filter(v => v.removed) || [];
      removed = [...removed, ...temp];
      if (this.UserMsg.payForMaterial == 1) {
        arr = arr.filter(v => v.fileType == 15 && !v.removed);
      }
      if (this.UserMsg.payForFont == 1) {
        arr = arr.filter(v => v.fileType != 15 && !v.removed);
      }

      arr = [...arr, ...removed];
      return arr;
    },
    loadVipSprites(data, puted) {
      data = this.filterPayForMaterial(data);
      this.vipSprite = [];
      let dataList = [];
      if (!puted) {
        this.limitNum.price = 0;
        this.limitNum.vip = 0;
        this.limitNum.svip = 0;
      }
      this.paginationNum = data.length;
      this.currentPage = 1;
      this.limitNum.vip += getVipSceneEffects(this.TOOL.sprites).length;
      for (let i = 0; i < data.length; i++) {
        let sprite = data[i];
        let typeData = {
            id: "",
            type: "",
            page: "",
            url: "",
            name: "",
            scale: "",
            removed: sprite.removed
          };
        let spriteData, scenesData;
        switch (sprite.type) {
          case "bg":
            typeData.id = sprite.scenesId;
            typeData.type = "bg";
            typeData.name = "背景";
            scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
            if (scenesData) {
              typeData.page = scenesData.index + 1;
              let t = scenesData.background.contentbg
                .find(".mask-blur")
                .prop("outerHTML");
              let $t = $(t).css({
                margin: 0,
                backgroundSize: "100% 100%",
              });
              typeData.url = $t[0].outerHTML;
              // scenesData.getThumbnails().then((data) => {
              //   typeData.scale = 70 / data.width;
              // });
            } else {
              typeData.page = sprite.sceneIndex + 1;
            }
            break;
          case "scenes":
            typeData.id = sprite.id;
            typeData.type = "scenes";
            typeData.name = "场景";

            scenesData = this.TOOL.getScenesIdData(sprite.id);
            typeData.page = scenesData.index + 1;
            scenesData.getThumbnails().then((data) => {
              typeData.url = data.dom;
              typeData.scale = 70 / data.width;
            });
            break;
          case "ScenesSound":
            typeData.type = "ScenesSound";
            typeData.id = sprite.scenesId;
            scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
            typeData.url =
              '<img src="static/svg/vip-sprites-music.svg" style="height: 100%;width: auto;"/>';
            typeData.name = "场景音乐";
            typeData.page = scenesData.index + 1;
            break;
          case "AllSound":
          case 'TOOLsound':
          case "sound":
            typeData.type = sprite.id;
            typeData.id = sprite.id;
            typeData.page = "/";
            switch (typeData.id) {
              case "TOOLsound":
                typeData.url =
                  '<img src="static/svg/vip-sprites-music.svg" style="height: 100%;width: auto;"/>';
                typeData.name = "背景音乐";
                break;
              case "AllSound":
                typeData.url =
                  '<img src="static/svg/vip-sprites-music.svg" style="height: 100%;width: auto;"/>';
                typeData.name = "全局录音";
                break;
            }
            break;
          case "uploadVideoNUM":
            let _vn = sprite.videoNum;
            let _dn = this.UserEquity.draftVideo;
            if (_vn > 3) {
              _dn = 3;
            }
            typeData.type = sprite.id;
            typeData.id = sprite.id;
            typeData.page = "/";
            typeData.url = "超过" + _dn + "个数量上限";
            typeData.name = "个人视频";
            break;
          case "groupSprites":
            scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
            let groupData = scenesData.getGroupData(sprite.id).data;
            typeData.id = sprite.id;
            typeData.type = sprite.type;
            typeData.page = scenesData.index + 1;
            typeData.url =
              '<img src="https://resources.laihua.com/' +
              groupData.thumbnailUrl +
              '" style="height: 100%;width: auto;"/>';
            typeData.name = "组合元素";
            typeData.scenesId = sprite.scenesId;
            break;
          default:
            spriteData = this.TOOL.findSpriteById(sprite.id);
            if (spriteData) {
              scenesData = this.TOOL.getScenesIdData(spriteData.scenesId);
              let scenesList =
                scenesData.fromJsonLoadingState === 2 &&
                scenesData.getSprites({ height: 40, width: 71 });
              // spriteData = this.TOOL.findSpriteById(sprite.id);
              typeData.id = sprite.id;
              typeData.page = scenesData.index + 1;
              typeData.url =
                spriteData.thumbnails &&
                spriteData.thumbnails.prop("outerHTML");
              typeData.name = this.judgeSpriteName(spriteData);
            } else {
              typeData.page = sprite.sceneIndex + 1;
              typeData.name = this.judgeSpriteName({
                option: sprite,
              });
            }
            typeData.type = "sprite";
            break;
        }
        typeData.limit = this.judgeLimit(sprite);
        dataList.push(typeData);
        const isVideoNum = sprite.videoNum && sprite.sprites;
        if (!puted && !isVideoNum) {
          if ("price" in sprite) {
            this.limitNum.price += 1;
          } else if (typeData.limit === "会员专属") {
            this.limitNum.vip += 1;
          } else if (typeData.limit === "企业会员专属") {
            this.limitNum.svip += 1;
          }
        }
      }

      dataList = this._sortItems(dataList);
      let pageItems = [];
      let pageSize = Math.ceil(dataList.length / 7);
      dataList.forEach((item, i) => {
        let j = i % 7;
        pageItems.push(item);
        if (j === 6 || i === dataList.length - 1) {
          this.vipSprite.push({
            data: pageItems,
            index: this.vipSprite.length + 1,
          });
          pageItems = [];
        }
      });

      this.listSize = this.getListSize();
    },
    getTextColor(name) {
      if (name === "企业会员专属") {
        return "#5778fb";
      } else if (name === "会员专属") {
        return "#f4c85b";
      } else {
        return void 0;
      }
    },
    _handleLimit(name) {
      if (name === "企业会员专属") {
        return 0;
      } else if (name === "会员专属") {
        return 1;
      } else {
        return 2;
      }
    },
    _sortItems(items) {
      return items
        .sort((a, b) => {
          let aLimit = this._handleLimit(a.limit);
          let bLimit = this._handleLimit(b.limit);
          return aLimit - bLimit;
        })
        .sort((a, b) => {
          let aPage = a.page === "/" ? 0 : a.page;
          let bPage = b.page === "/" ? 0 : b.page;
          return aPage - bPage;
        });
    },
    judgeSpriteName(data) {
      let name = "";
      if (data.option && data.option.fileType) {
        data.option.fileType = data.option.fileType - 0;
        switch (data.option.fileType) {
          case 1: // 静态素材-png,jpg等
          case 2: // 静态素材-svg
            name = "背景";
            break;
          case 3: // 静态素材-png,jpg等
          case 4: // svg
          case 5: // lottie
          case 22: // svg
          case 35: // 相框
          case 41: // 特效
          case 42: // 有声素材
          case 43: // 捏脸元素
          case 44: // 贴图-动态
            name = "道具";
            break;
          case 6: // 静态素材-png,jpg等
          case 7: // svg
          case 8: // lottie
          case 9: // 动态素材图表-json
          case 23: // svg
          case 29: // 可编辑颜色、线条粗细的svg
          case 33: // gif
            name = "形状";
            break;
          case 10: // lottie
            name = "角色";
            break;
          case 11: // 静态素材-png,jpg等
          case 12: // svg
          case 13: // json
          case 15: // 文字字体
          case 30: // 文字组合
            name = "文字";
            break;
          case 32: // gif
            name = "GIF";
            break;
        }
      } else {
        switch (data.type) {
          case "Chart":
            name = "形状";
            break;
          case "Image":
          case "Svg":
            name = "图片";
            break;
          case "Text":
            name = "文字";
            break;
          case "RichText":
            name = "富文本";
            break;
          case "Lottie":
            name = "动画素材";
            break;
        }
      }
      return name;
    },
    delStepFS() {
      this.delStep = 1;
      let listFS = [];
      for (let i = 0; i < this.vipSprite.length; i++) {
        for (let j = 0; j < this.vipSprite[i].data.length; j++) {
          let sprite = this.vipSprite[i].data[j],
            scenesData,
            thisFS;

          if (!sprite.removed) {
            continue;
          }

          switch (sprite.type) {
            case "sprite":
              thisFS = () => {
                this.TOOL.removeSprite(sprite.id, true);
              };
              break;
            case "scenes":
              thisFS = () => {
                if (this.TOOL.sprites.length === 1) {
                  this.TOOL.addScenes(null, null, true).then((scenes) => {
                    this.TOOL.removeScenes(sprite.id);
                    this.TOOL.selectScenes(scenes).then((data) => {
                      // this.TOOL.moveScenesTo(scenes.id, scenesIndex);
                    });
                  });
                } else {
                  this.TOOL.removeScenes(sprite.id);
                }
              };
              break;
            case "ScenesSound":
              scenesData = this.TOOL.getScenesIdData(sprite.id);
              thisFS = () => {
                scenesData.clearSound();
              };
              break;
            case "AllSound":
              thisFS = () => {
                this.TOOL.clearSoundRecord({ undo: true });
              };
              break;
            case "TOOLsound":
              thisFS = () => {
                this.TOOL.setSound({}, true);
              };
              break;
            case "bg":
              scenesData = this.TOOL.getScenesIdData(sprite.id);
              let bgOpts = {
                // 设置场景背景
                resourceId: null, // 背景资源id
                fileType: null, // 背景资源type
                type: "Color",
                data: {
                  color: "#FFFFFF",
                  blur: 0,
                  opacity: 1,
                },
                zoomActive: false,
              };

              thisFS = () => {
                this.$store.commit("del_vipSprites", {
                  id: "BG-" + scenesData.id,
                });
                scenesData.setBackground(bgOpts, null, true);
              };
              break;
            case "groupSprites":
              scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
              let groupSprites = scenesData.getGroupData(sprite.id).sprites;
              thisFS = () => {
                for (let c = 0; c < groupSprites.length; c++) {
                  this.TOOL.removeSprite(groupSprites[c].id, true);
                }
              };
              break;
          }
          listFS.push(thisFS);
        }
      }
      let mergePromise = (ajaxArray) => {
        var data = [];
        var sequence = Promise.resolve();
        ajaxArray.forEach(function (item) {
          sequence = sequence.then(item).then(function (res) {
            data.push(res);
            return data;
          });
        });

        return sequence;
      };

      // this.removeVideos()
      Promise.resolve().then(() => {
        mergePromise(listFS).then((data) => {
          // this.$bus.emit('updateAllScenes', this.TOOL.sprites);
          this.delStep = 2;
          let timeoutid = setTimeout(() => {
            this.closeModal();
            clearTimeout(timeoutid);
            // this.TOOL.selectScenes(this.TOOL.sprites[0]);
            this.selectEachScene();
          }, 2000);
        });
      });
    },
    async selectEachScene () {
      let scenes = this.TOOL.sprites;
      for (let i = 0; i < scenes.length; i++) {
        await this.TOOL.selectScenes(scenes[i]);
      }
      this.TOOL.selectScenes(this.TOOL.sprites[0]);
    },
    removeVideosx() {
      let scenes = this.TOOL.sprites;
      let len = scenes.length;
      for (let i = len - 1; i > 0; i--) {
        let bgData = scenes[i].background.data;
        let type = bgData.type;
        let fileType = bgData.fileType;
        if (type === "Video" && fileType !== 25) {
          let bgOpts = {
            // 设置场景背景
            resourceId: null, // 背景资源id
            fileType: null, // 背景资源type
            type: "Color",
            data: {
              color: "#FFFFFF",
              blur: 0,
              opacity: 1,
            },
            zoomActive: false,
          };
          scenes[i].setBackground(bgOpts, null, false);
        }

        let sprites = scenes[i].sprites;
        sprites.some((sprite) => {
          let isPV =
            sprite.option.fileType === 26 || sprite.option.fileType === 27;
          if (isPV) {
            this.TOOL.removeSprite(sprite.id, false);
          }
          return isPV;
        });
      }
    },
    removeVideosxx() {
      let items = this.getVideoArr();
      let task;
      let tasks = [];
      for (let i = items.length - 1; i > 0; i--) {
        let item = items[i];
        if (!item.type) {
          let bgOpts = {
            // 设置场景背景
            resourceId: null, // 背景资源id
            fileType: null, // 背景资源type
            type: "Color",
            data: {
              color: "#FFFFFF",
              blur: 0,
              opacity: 1,
            },
            zoomActive: false,
          };
          task = item.setBackground(bgOpts, null, false);
        } else {
          task = this.TOOL.removeSprite(item.id, false);
        }

        tasks.push(task);
      }

      return Promise.all(tasks);
    },
    removeVideos() {
      let scenesMax = [];
      let spritesMax = [];
      (this.IsVipSprites.data || []).forEach((v) => {
        if (v.scenes && v.scenes.length > scenesMax.length) {
          scenesMax = v.scenes;
        }
        if (v.sprites && v.sprites.length > spritesMax.length) {
          spritesMax = v.sprites;
        }
      });
      scenesMax.forEach(({ id } = {}) => {
        if (this.FreeVideoIds.indexOf(id) > -1) {
          return;
        }
        let bgOpts = {
          // 设置场景背景
          resourceId: null, // 背景资源id
          fileType: null, // 背景资源type
          type: "Color",
          data: {
            color: "#FFFFFF",
            blur: 0,
            opacity: 1,
          },
          zoomActive: false,
        };
        let item = this.TOOL.getScenesIdData(id);
        item.setBackground(bgOpts, null, false);
      });
      spritesMax.forEach(({ id } = {}) => {
        if (this.FreeVideoIds.indexOf(id) > -1) {
          return;
        }
        this.TOOL.removeSprite(id, false);
      });

      this.$store.commit("save_freeVideoIds", []);
      return Promise.resolve();
    },
    lookSpritePosition(data) {
      let scenesData = "",
        lookFS = () => {};
      switch (data.type) {
        case "sprite":
          let sprite = this.TOOL.findSpriteById(data.id);
          scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
          scenesData.nowTime = sprite.effect.exitAnim.start / 1000;
          lookFS = () => {
            this.TOOL.selectSprite([sprite]);
            eve("timeline_nowTime_change", null, {
              nowTime: sprite.effect.exitAnim.start / 1000,
            });
          };
          break;
        case "scenes":
          scenesData = this.TOOL.getScenesIdData(data.id);
          break;
        case "ScenesSound":
          scenesData = this.TOOL.getScenesIdData(data.id);
          lookFS = () => {
            this.$bus.emit("FeaturesPop_vue", {
              name: "volume_adjust",
              posx: 0,
              posy: 0,
              type: 1,
            });
          };
          break;
        case "AllSound":
        case "TOOLsound":
          lookFS = () => {
            this.$bus.emit("FeaturesPop_vue", {
              name: "volume_adjust",
              posx: 0,
              posy: 0,
              type: 1,
            });
          };
          break;
        case "bg":
          scenesData = this.TOOL.getScenesIdData(data.id);
          break;
        case "groupSprites":
          scenesData = this.TOOL.getScenesIdData(data.scenesId);
          let groupSprites = scenesData.getGroupData(data.id).sprites,
            nowTime = 0;

          for (let c = 0; c < groupSprites.length; c++) {
            if (nowTime) {
              nowTime =
                groupSprites[c].effect.exitAnim.start / 1000 > nowTime
                  ? nowTime
                  : groupSprites[c].effect.exitAnim.start / 1000;
            } else {
              nowTime = groupSprites[c].effect.exitAnim.start / 1000;
            }
          }
          lookFS = () => {
            this.TOOL.selectSprite(groupSprites);
            eve("timeline_nowTime_change", null, { nowTime: nowTime });
          };
          break;
      }
      if (scenesData.id == this.SelectScenes_Msg.id || !scenesData) {
        lookFS();
        this.closeModal();
      } else {
        this.TOOL.selectScenes(scenesData).then((data) => {
          lookFS();
          this.closeModal();
        });
      }
    },
    upgradeVIP () {
      this.$memberGuide({
        show: true,
        context: this,
        funcRight: {
          type: "",
          name: "",
        },
      });
    },
    upgradeVIPOld() {
      let num  = 0;
      switch (this.boxType) {
        case 'preview':
        num = 16;
        break;
        case 'export':
        num = 15;
        break;
        case 'authority':
        num = 14;
        break;
      }
      if (this.limitNum.svip) {
        // window.open(`/vip?page=${num}`);
        window.open(`/workplace/pricing?page=${num}`);
      } else if (this.UserLevelType == 0 && !this.isPersonVip) {
        // window.open(`/vipsolo?page=${num}`);
        window.open(`/workplace/pvip?page=${num}`);
      } else {
        // window.open(`/vip?page=${num}`);
        window.open(`/workplace/pricing?page=${num}`);
      }
      this.$util.localStorage.set("sensorWebPurchaseVipSource", {
        val: {
          routename: "tool",
          // page: "编辑器-素材购物车-会员引导按钮",
          page: "编辑器-使用权限提示",
        }
      });
      this.$util.localStorage.set("sensorWebPayVipSource", {
        val: {
          routename: "tool",
          // page: "编辑器-素材购物车-会员引导按钮",
          page: "编辑器-使用权限提示",
        }
      });
      this.$util.localStorage.set('saPurchaseSource', {
        fullPath: '/tool'
      });
      this.$bus.emit("FeaturesPop_vue", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        fs: "payPriceEvent_vue",
        msgType: 2,
        type: 2,
      });
      // this.closeModal();
    },
    judgeLimit(data) {
      if (data.payType == 6) {
        return '企业会员专属';
      }
      if (data.payType == 4) {
        return '会员专属';
      }
      if (data.price != null && typeof data.price === 'number') {
        return "¥ " + data.price;
      } else if ("fileType" in data) {
        switch (data.type) {
          case "bg":
            if (data.fileType == 25) {
              // this.limitNum.svip += 1;
              return "企业会员专属";
            } else {
              return "会员专属";
            }
          default:
            return "会员专属";
        }
      } else {
        switch (data.type) {
          case "uploadVideoNUM":
            if (data.videoNum > 3) {
              this.limitNum.svip += (data.videoNum - 3);
              if (this.UserEquity.draftVideo === 1) {
                this.limitNum.vip += 2;
              }
              return "企业会员专属";
            } else {
              if (this.UserEquity.draftVideo === 1) {
                this.limitNum.vip += (data.videoNum - 1);
              }
              return "会员专属";
            }
          case "Chart":
            // this.limitNum.svip += 1;
            return "企业会员专属";
          default:
            return "会员专属";
        }
      }
    },
    limitJudgeFS(type) {
      let dataList = [];
      for (let i = 0; i < this.IsVipSprites.data.length; i++) {
        let item = this.IsVipSprites.data[i];

        switch (type) {
          case "all":
            dataList.push(item);
            break;
          case "pay":
            if ("price" in item) {
              dataList.push(item);
            }
            break;
          case "vip":
            if (!item.price) {
              dataList.push(item);
            }
            break;
        }
      }
      this.limitJudge = type;
      this.loadVipSprites(dataList, true);
    },
    msgpopupsFS(data) {
      let message = "";
      switch (data) {
        case "delStep":
          this.judgeMsgpopups.judge = true;
          this.judgeMsgpopups.type = "delStep";
          // this.judgeMsgpopups.message = "请确认要一键删除所选付费资源吗？";
          this.judgeMsgpopups.message = "请确认要一键删除所选已下架资源吗？";
          this.judgeMsgpopups.btnMsg.left.title = "确认";
          this.judgeMsgpopups.btnMsg.right.title = "取消";
          break;
        case "upgradeVIP":
          // message = '本次会员升级操作可解锁会员素材' + this.limitNum.vip + '个';

          // if (this.limitNum.price) {
          //   message += '<br/>另外需单独购买的素材资源' + this.limitNum.price + '个，请确认！';
          // }
          message = "<span>您所使用的素材权限包括：";
          if (this.limitNum.vip) {
            message += "<br/>会员专属素材" + this.limitNum.vip + "个";
          }
          if (this.limitNum.svip) {
            message += "<br/>企业会员专属素材" + this.limitNum.svip + "个";
          }
          if (this.limitNum.price) {
            message += "<br/>单独付费素材" + this.limitNum.price + "个";
          }
          message +=
            "<br/>升级<strong>动画Pro+</strong>即可<strong>解锁全站素材</strong><br/>请确认您的素材需求并进行升级</span>";

          this.judgeMsgpopups.judge = true;
          this.judgeMsgpopups.type = "upgradeVIP";
          this.judgeMsgpopups.message = message;
          this.judgeMsgpopups.btnMsg.left.title = "升级会员";
          this.judgeMsgpopups.btnMsg.right.title = "稍后回来";
          break;
        case "payPrice":
          message = "<span>您所使用的素材权限包括：";
          if (this.limitNum.vip) {
            message += "<br/>会员专属素材" + this.limitNum.vip + "个";
          }
          if (this.limitNum.svip) {
            message += "<br/>企业会员专属素材" + this.limitNum.svip + "个";
          }
          if (this.limitNum.price) {
            message += "<br/>单独付费素材" + this.limitNum.price + "个";
          }
          message +=
            "<br/>升级<strong>动画Pro+</strong>即可<strong>解锁全站素材</strong><br/>请确认您的素材需求并进行升级</span>";

          this.judgeMsgpopups.judge = true;
          this.judgeMsgpopups.type = "payPrice";
          this.judgeMsgpopups.message = message;
          this.judgeMsgpopups.btnMsg.left.title = "继续购买";
          this.judgeMsgpopups.btnMsg.right.title = "稍后回来";
          break;
      }
    },
    payPriceFS() {
      this.$bus.emit("payPriceEvent_vue", { type: true });
    },
    msgpopupsBtnFS(type) {
      switch (type) {
        case "left":
          switch (this.judgeMsgpopups.type) {
            case "delStep":
              this.delStepFS();
              // this.$bus.emit('rmAbandon');
              break;
            case "upgradeVIP":
              this.upgradeVIP();
              break;
            case "payPrice":
              this.payPriceFS();
              break;
          }
          this.msgpopupsBtnFS("none");
          break;
        case "right":
          switch (this.judgeMsgpopups.type) {
            case "upgradeVIP":
            case "delStep":
            case "payPrice":
              this.msgpopupsBtnFS("none");
              break;
          }
          break;
        default:
          this.judgeMsgpopups.judge = false;
          this.judgeMsgpopups.type = "";
          this.judgeMsgpopups.message = "";
          this.judgeMsgpopups.btnMsg.left.title = "";
          this.judgeMsgpopups.btnMsg.right.title = "";
          break;
      }
    },
    getListSize() {
      let len = this.vipSprite.length;
      if (len > 1) {
        return 7 * (len - 1) + this.vipSprite[len - 1].data.length;
      } else {
        try {
          return this.vipSprite[0].data.length;
        } catch (e) {
          return 0;
        }
      }
    },
    getSoundCoupon() {
      this.$http
        .get("/api/user/coupon", {
          params: {
            type: 1,
            goodsType: 12,
          },
        })
        .then((res) => {
          this.$store.commit("save_soundCoupon", {
            num: res.data.total || 0,
          });
        })
        .catch((err) => console.warn(err));
    },
    isBigDialog() {
      return (
        this.judgeMsgpopups.type === "upgradeVIP" ||
        this.judgeMsgpopups.type === "payPrice"
      );
    },
    async editorLoadMore() {
      //对未加载的场景页进行加载
      this.$bus.emit('loadingAllScenes', 'start')
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        $(this.$el).hide();
        const scenes = this.TOOL.sprites[i];
        if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
          await this.TOOL.selectScenes(scenes);
          await scenes.fromJson(
            scenes.unLoadData.json,
            this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
            true
          );
        }
        //初始化一些动画资源
        await scenes.activeAnimation();
      }
      this.$bus.emit('loadingAllScenes', 'end')
    },
  },
};
</script>

<style lang="scss" scoped>
.delVip {
  position: relative;
  background: rgba(0, 0, 0, .5);
  .delLoad,
  .delMsg,
  .vipSpriteBox {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background: #fff;
  }

  .vipSpriteBox {
    width: 780px;
    height: 638px;
    box-shadow: 0 0 4px 0 rgba(54, 76, 204, .4);
    border-radius: 8px;
    // overflow: hidden;

    .headBar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0 15px;
      color: #474261;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-stretch: normal;
      font-weight: normal;
      letter-spacing: 0;
      background-color: #d9ddea;
      border-radius: 8px 8px 0 0;

      .icon {
        width: 12px;
        width: 20px;
        height: 12px;
        height: 20px;
        color: #474261;
        font-size: 20px;
        cursor: pointer;
        &:hover {
          color: #000;
        }
      }
    }

    .scollBox_title {
      display: flex;
      height: 40px;
      background-color: #f0f0f8;
       > div {
        width: 25%;
        height: 100%;
        color: #474261;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-stretch: normal;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0;
      }
      .limitBtn {
        position: relative;
        cursor: pointer;

        &:before {
          content: "";
          position: absolute;
          top: 15px;
          right: 26px;
          width: 0;
          height: 0;
          border-color: #474261 transparent transparent;
          border-style: solid;
          border-width: 7px 7px 0;
        }
        &:hover {
          .limitBox {
            display: block;
          }
        }
        .limitBox {
          position: absolute;
          bottom: -115px;
          left: 34px;
          z-index: 20;
          display: none;
          overflow: hidden;
          width: 96px;
          height: 120px;
          background-color: #fff;
          box-shadow: 0 0 8px 0 rgba(26, 42, 130, .26);
          border-radius: 4px;
           > div {
            width: 96px;
            height: 40px;

            &:hover {
              background-color: #f0f0f8;
            }
          }
          .limitActive {
            background-color: #f0f0f8;
          }
        }
      }
    }

    .scollBox {
      position: relative;
      width: 780px;
      height: 350px;

      ul {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
         > li {
          display: flex;
          width: 100%;
          height: 50px;
          color: #474261;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-stretch: normal;
          font-weight: normal;
          line-height: 50px;
          letter-spacing: 0;
          border-bottom: 1px solid #f0f0f8;

           > div {
            width: 25%;
            height: 100%;
          }
          .thumbnails {
            position: relative;

             > div {
              position: absolute;
              width: 71px;
              height: 40px;
            }
            .sprite_thumbnails {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              margin: auto;
            }
            .uploadVideoNUM {
              width: 100%;
            }
            .scenes_thumbnails {
              top: -14px;
              left: 10px;
            }
          }
          .lookSprite {
            cursor: pointer;
            &:hover {
              color: #5778fb;
            }
          }
        }
      }
    }

    .bottom_bens {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: 80px;
      padding: 0 18px;
      border-top: 2px solid #f0f0f8;

       > a {
        text-decoration: inherit;
      }

      .icon {
        width: 100px;
        height: 40px;
        margin-left: 15px;
        color: #474261;
        line-height: 40px;
        background-color: #eaeaf6;
        border-radius: 8px;
        cursor: pointer;

        &:hover {
          color: #fff;
          background-color: #5778fb;
        }
      }
      .a_icon {
        color: #fff;
        background: #5778fb;
      }
      .icon_a {
        position: absolute;
        top: 18px;
        left: 18px;
        margin: 0;
      }
      .delIcon {
        color: #fff;
        background-color: #e53449;

        &:hover {
          color: #fff;
          background-color: #e53449;
          opacity: .8;
        }
      }
    }
  }
  .vip_pagination {
    margin-top: 30px;
  }

  .delLoad,
  .delMsg {
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(44, 75, 248, .2);
    border-radius: 8px;
    opacity: .9;
  }
  .delMsg {
    width: 388px;
    height: 108px;
    color: #474261;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-stretch: normal;
    font-weight: normal;
    line-height: 108px;
    letter-spacing: 0;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(44, 75, 248, .2);
    border-radius: 8px;
    opacity: .9;
  }
  .delLoad {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 299px;
    height: 100px;
    color: #5778fb;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-stretch: normal;
    font-weight: normal;
    letter-spacing: 0;

    .load {
      width: 20px;
      height: 20px;
      margin-right: 15px;
      background: #5778fb;
              animation: myRotate 3s linear infinite;

      -webkit-animation: myRotate 3s linear infinite;
    }
  }

  .msgpopups {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);

    .msgpopups_box {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 540px;
      height: 220px;
      padding: 48px 56px;
      margin: auto;
      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(54, 76, 204, .4);
      border-radius: 4px;

      .delMsgpopups {
        position: absolute;
        top: 13px;
        right: 13px;
        color: #737596;
        font-size: 25px;
        font-weight: 700;
        cursor: pointer;
      }
      .msgpopups_body {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        margin-bottom: 20px;
        color: #474261;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-stretch: normal;
        font-weight: normal;
        line-height: 1.8;
        letter-spacing: 0;
      }
      .msgpopups_footer {
        display: flex;
        justify-content: space-between;
        height: 40px;
        padding-right: 30px;
        padding-left: 30px;
        color: #474261;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-stretch: normal;
        font-weight: normal;
        line-height: 40px;
        letter-spacing: 0;
         > div {
          width: 120px;
          height: 40px;
          background-color: #eaeaf6;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
}
@-webkit-keyframes myRotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.item-price {
  display: flex;
  justify-content: center;
  align-items: center;
  & > .msg {
    margin-right: .6em;
    color: red;
  }
  & > .is-msg {
    position: relative;
    &.del:before {
      content: " ";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #333;
      // transform: scalex(1.6) rotate(45deg);
      transform: scalex(1.2);
    }
  }
}

.vip-icon {
  position: relative;
  display: inline-block;
  &:hover {
    .vip-icon-tip {
      display: inline-block;
    }
  }
}
.vip-icon-tip {
  position: absolute;
  top: 50%;
  left: 100%;
  display: none;
  box-sizing: content-box;
  width: 240px;
  padding: 8px;
  color: #fff;
  font-size: 12px;
  line-height: 1.2;
  text-align: left;
  background-color: rgba(#000, .5);
  border-radius: 4px;
  transform: translateY(-50%);
}

.msg-vip {
  position: absolute;
  bottom: 94px;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 480px;
  height: 36px;
  margin: auto;
  margin-top: 13px;
  background-image: linear-gradient(175deg, #ffd289 0%, #ffbc76 100%);
  border-radius: 18px;
  transform: translateX(-50%);
}
.up-member {
  &:hover {
    background-color: #5656e8 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/deleteVipSprites.vue